/**
 * Header　スティッキー
 */
!function(){
	var timeoutId;
	function setHeaderSticky(){
		var $header = $('#globalHeader');
		var height = $header.get(0).clientHeight;
		var $body = $('body');
		$header.addClass('js-header-sticky');
		$body.css('margin-top',height+'px');
	}

	$(window).on('load',setHeaderSticky);
	window.addEventListener("resize",function () {
		clearTimeout(timeoutId) ;
		timeoutId = setTimeout(setHeaderSticky,500);
	});
}();

/**
 * Header　スマートフォン　アコーディオン　メニュー　
 */
!function(){
	var $menu = $('.js-sp-toggle-menu');
	for(var i = 0;i < $menu.length;++i){
		if($menu.eq(i).find('.g-header__menu-overlay').length !== 0){
			$($menu).eq(i).find('.g-header__menu--link').addClass('js-sp-toggle-menu__btn');
		}
	}
	$(document).on('click','.js-sp-toggle-menu__btn',function(e){
		if(document.body.clientWidth > 900) return true;
		e.preventDefault;
		$(this).toggleClass('_open');
		$(this).next('.g-header__menu-overlay').slideToggle();
		return false;
	});
}();

/**
 * Header SmartPhone Menu
 */
!function(){
	function toggleSpMenu(button){
		var $btnThis = button;
		var $btnMenu = $('.g-header__sp-toggle__menu');
		var $btnSearch = $('.g-header__sp-toggle__search');
		var $side = $('.js-header__sp--side');
		var $menu = $side.find('.js-header__sp--side__menu');
		var $search = $side.find('.js-header__sp--side__search');
		if($side.is(':visible') && $btnThis.hasClass('g-header__sp-toggle__menu')){
			$btnSearch.removeClass('_active').addClass('_close');
			$search.slideUp();
		} else if($menu.is(':visible') && $btnThis.hasClass('g-header__sp-toggle__search')) {
			$btnMenu.removeClass('_active').addClass('_close');
			$menu.slideUp();
		}
		if($btnThis.hasClass('g-header__sp-toggle__menu')){
			if($menu.is(':hidden')){
				$btnMenu.removeClass('_close').addClass('_active');
				$side.show();
				$menu.slideDown();
			} else {
				$btnMenu.removeClass('_active').addClass('_close');
				$menu.slideUp('normal',function(){
					$side.hide();
				});
			}
		}
		if($btnThis.hasClass('g-header__sp-toggle__search')){
			if($search.is(':hidden')){
				$btnSearch.removeClass('_close').addClass('_active');
				$side.show();
				$search.slideDown();
			} else {
				$btnSearch.removeClass('_active').addClass('_close');
				$search.slideUp('normal',function(){
					$side.hide();
				});
			}
		}
	}
	$(document).on('click','.g-header__sp-toggle__menu,.g-header__sp-toggle__search',function(e){
		e.preventDefault;
		toggleSpMenu($(this));
		return false;
	});
}();